import { AsyncPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc/misc.module';
import { RedirectPageRoutingModule } from './redirect-routing.module';
import { RedirectPageComponent } from './redirect.page';

@NgModule({
  declarations: [RedirectPageComponent],
  imports: [IonicModule, MiscModule, RedirectPageRoutingModule, AsyncPipe, DatePipe]
})
export class RedirectPageModule {}
